import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Flex, theme, Typography } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { formatDate } from '@app/services/date';
import { WarehouseErrorMarker } from '@components/orders';

import type { ITask, ITaskDragData } from './interfaces';
import { CardStyled, ListItemStyled } from './styles';

interface TaskCardProps {
  task: ITask;
  isOverlay?: boolean;
  onCardClick?: (uid: string) => void;
}

export function TaskCard({ task, isOverlay, onCardClick }: TaskCardProps) {
  const { token } = theme.useToken();
  const orderT = useTranslation(NSKeys.order);
  const ordersT = useTranslation(NSKeys.orders);
  const { setNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({
    id: task.id,
    data: {
      type: 'Task',
      task,
    } as ITaskDragData,
    attributes: {
      roleDescription: 'Task',
    },
  });

  const style = {
    transition,
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? '0.4' : '1',
    border: isOverlay ? `1px solid ${token.colorPrimary}` : '',
  };

  return (
    <CardStyled ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Flex align="center" gap={8}>
        {task.permissionView && onCardClick ? (
          <ListItemStyled style={{ cursor: 'pointer', display: 'inline-block' }} onClick={() => onCardClick(task.id)}>
            <Typography.Link className="listItemTitle">
              {ordersT.t('tableColumns.num')} {task.num}
            </Typography.Link>
          </ListItemStyled>
        ) : (
          <ListItemStyled>
            <Typography.Text type="secondary">
              {ordersT.t('tableColumns.num')} {task.num}
            </Typography.Text>
          </ListItemStyled>
        )}
        <WarehouseErrorMarker error={task.warehouseError} fontSize={16} />
      </Flex>

      {task.cityName && (
        <ListItemStyled>
          <Typography.Text>{`${ordersT.t('tableColumns.city')}: ${task.cityName}`}</Typography.Text>
        </ListItemStyled>
      )}

      {task.recipientName && (
        <ListItemStyled>
          <Typography.Text>{`${ordersT.t('tableColumns.recipient')}: ${task.recipientName}`}</Typography.Text>
        </ListItemStyled>
      )}

      {task.deliveryDate && (
        <ListItemStyled>
          <Typography.Text>
            {`${orderT.t('blockDelivery.delivery_date')}: ${formatDate(task.deliveryDate)}`}
          </Typography.Text>
        </ListItemStyled>
      )}
      {/* <ListItemStyled> */}
      {/*   <Typography.Text type="secondary" className="listItemTitle"> */}
      {/*     {orderT.t('blockInfo.created_at')}: */}
      {/*   </Typography.Text> */}
      {/*   <Typography.Text>{formatDateAndTimeShort(task.created_at)}</Typography.Text> */}
      {/* </ListItemStyled> */}
    </CardStyled>
  );
}
